<div id="loginContainer" class="backgroundSand">
  <div class="loginImg">
    <img
      src="../../../assets/images/login/LogoTritonText1.png"
      alt="Logo de triton"
    />
  </div>
  <div class="formContainer">
    <form class="loginForm" #f="ngForm" (ngSubmit)="onDownload()" novalidate>
      <h5 class="mb-4">
        <strong>DESCARGA DE CERTIFICADOS CON FIRMA ELECTRÓNICA</strong>
      </h5>
      <div class="formCVE">
        <strong>Por favor, introduzca:</strong>
        <br />
        <strong>Código de verificación electrónico (CVE)</strong>

        <div class="inputText mb-3">
          <input type="text" [(ngModel)]="cve" name="cve" required />
        </div>

        <strong>Número de solicitud</strong>

        <div class="inputText mb-3">
          <input type="text" [(ngModel)]="numDoc" name="numDoc" required />
        </div>

        <button class="submitButton">Descargar</button>
      </div>
    </form>
  </div>

  <div class="brands backgroundWhite">
    <div class="brandLogo">
      <img
        class="seat"
        src="../../../assets/images/login/seat.png"
        alt="Logo de Seat"
      />
    </div>
    <div class="brandLogo">
      <img
        class="cupra"
        src="../../../assets/images/login/cupra.png"
        alt="Logo de Cupra"
      />
    </div>
    <div class="brandLogo">
      <img
        class="vw"
        src="../../../assets/images/login/ww1.png"
        alt="Logo de VW"
      />
    </div>
    <div class="brandLogo">
      <img
        class="audi"
        src="../../../assets/images/login/audi.png"
        alt="Logo de Audi"
      />
    </div>
    <div class="brandLogo">
      <img
        class="skoda"
        src="../../../assets/images/login/skoda.png"
        alt="Logo de Skoda"
      />
    </div>
    <div class="brandLogo">
      <img
        src="../../../assets/images/login/ww2.png"
        alt="Logo grupo VW"
        class="comerciales"
      />
    </div>
  </div>
</div>
